import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // IMPORT ZAROORI HAI

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* SIRF YAHAN ROUTER HONA CHAHIYE */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);